// Dependencies
import React from 'react';

// Components
import NewsletterForm from '../../newsletter/newsletterForm/newsletterForm';

// Styles
import BlogPostNewsletterFormStyles from './blogPostNewsletterForm.styles';

export default function BlogPostNewsletterForm() {
  return (
    <BlogPostNewsletterFormStyles>
      <NewsletterForm blog />
    </BlogPostNewsletterFormStyles>
  );
}

BlogPostNewsletterForm.propTypes = {};

BlogPostNewsletterForm.defaultProps = {};
